import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource/chivo/400.css";
import "@fontsource/chivo/700.css";
import "@fontsource/chivo/900.css";
import "./index.css";
import App from "./App";

// Suppress R3F reconciler warnings in CRA dev error overlay
// These are non-fatal warnings from React Three Fiber v9 + React 19's StrictMode
if (process.env.NODE_ENV === 'development') {
  const suppress = (e) => {
    if (e?.message?.includes?.('R3F') || e?.message?.includes?.('line-number') || e?.reason?.message?.includes?.('R3F')) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return true;
    }
  };
  window.addEventListener('error', suppress, true);
  window.addEventListener('unhandledrejection', suppress, true);

  // Auto-dismiss CRA error overlay if it appears for R3F warnings
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.tagName === 'IFRAME' && node.id === 'webpack-dev-server-client-overlay') {
          try {
            const checkAndRemove = () => {
              try {
                const doc = node.contentDocument || node.contentWindow?.document;
                if (doc?.body?.textContent?.includes?.('R3F') || doc?.body?.textContent?.includes?.('line-number')) {
                  node.remove();
                }
              } catch (e) { /* cross-origin */ }
            };
            node.addEventListener('load', checkAndRemove);
            setTimeout(checkAndRemove, 500);
            setTimeout(checkAndRemove, 1500);
          } catch (e) { /* ignore */ }
        }
      }
    }
  });
  observer.observe(document.body, { childList: true });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
